import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './event-form-module.pcss'

const EventFormModule = ({ children, className, expanded }) => {
    return (
        <div
            className={classNames(
                'event-form-module',
                { 'event-form-module--expanded': expanded },
                className
            )}
        >
            {children}
        </div>
    )
}

EventFormModule.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string.isRequired,
    expanded: PropTypes.bool,
}

export default EventFormModule

export const EventFormModuleLeftRightContainer = ({ children = null }) => {
    return (
        <div className="event-form-module__left-right-container">
            {children && children}
        </div>
    )
}

export const EventFormModuleLeft = ({ children = null }) => {
    return (
        <div className="event-form-module__left">
            {children && children}
        </div>
    )
}

export const EventFormModuleRight = ({ children = null }) => {
    return (
        <div className="event-form-module__right">
            {children && children}
        </div>
    )
}
